<template>
  <SectionGroup gap="medium">

    <slot />

    <SectionBox shadow="none">
      <BasicSection>
        <slot name="filters" />
      </BasicSection>

      <StickyBox>
        <SubmitBox appearance="opaque">
          <BasicSection appearance="submit">
            <slot name="submit-button">
              <BasicButton
                @click="$emit('submit')"
                appearance="primary"
                fullWidth
                size="xl"
              >{{submitTitle}}</BasicButton>
            </slot>
          </BasicSection>
        </SubmitBox>
      </StickyBox>
    </SectionBox>

  </SectionGroup>
</template>

<script>
  import BasicButton from 'src/components/BasicButton/BasicButton.vue';
  import SectionBox from 'src/components/SectionBox/SectionBox.vue';
  import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';
  import SectionGroup from 'src/components/sections/SectionGroup/SectionGroup.vue';
  import StickyBox from 'src/components/sections/StickyBox/StickyBox.vue';
  import SubmitBox from 'src/components/SubmitBox/SubmitBox.vue';

  export default {
    name: 'FiltersSubmitScreen',
    components: { BasicButton, SubmitBox, StickyBox, BasicSection, SectionBox, SectionGroup },
    props: {
      submitTitle: String,
    }
  }
</script>